// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hy59","buttons":"styles_buttons__3bghk"};